import React from "react";
import { useState } from "react";
import { useSelector } from "types/store";
import * as nextReducer from "containers/Next/NextReducer";
import FineTuneDataButton from "components/LanguageModelArtifact/FineTuningButton/FineTuneDataButton";
import CreateAndTrainModal from "components/LanguageModelArtifact/CreateAndTrainModal";
import * as chatDetailsReducer from "containers/ChatDetails/reducer";
const FineTuningButton = ({ templateName }) => {
    const [showTrainingModal, updateShowTrainingModal] = useState(false);
    const nextId = useSelector((state) => nextReducer.getCurrentNextId(state));
    // Reusing similar logic to ResponseDataTable component which shows the rows of feedback.
    const likedDetails = useSelector((state) => chatDetailsReducer.getLikedDetailsForReports(state, [nextId]));
    const validDetails = likedDetails?.filter((detail) => detail.results);
    const responseData = validDetails.flatMap((chatDetail) => {
        return chatDetail.results.filter((r) => (r.like_count > 0 || chatDetail.like_count > 0) && r?.task_name !== "rephrase_query");
    });
    const totalFeedbackCount = responseData?.length;
    return (React.createElement("div", null,
        React.createElement(FineTuneDataButton, { onClick: () => updateShowTrainingModal(true), fineTuningRowCount: totalFeedbackCount }),
        React.createElement(CreateAndTrainModal, { showModal: showTrainingModal, updateShowModal: updateShowTrainingModal, projectFeedbackCount: totalFeedbackCount, nextId: nextId, templateName: templateName })));
};
export default FineTuningButton;
